import * as React from 'react';
import { cn } from '../../lib/utils';
import { Alert, AlertTitle, AlertDescription } from './alert';
import { Button } from './button';

/**
 * ErrorState component for list views when a data fetch fails.
 * Renders a destructive Alert with the error message and a Retry button.
 * Ensures no blank page is shown when an error occurs.
 */
interface ErrorStateProps {
  readonly message: string;
  readonly onRetry: () => void;
  readonly className?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry, className }) => (
  <Alert variant="destructive" className={cn('mx-auto max-w-md', className)}>
    <AlertTitle>Error</AlertTitle>
    <AlertDescription className="mt-2 flex flex-col gap-3">
      <span>{message}</span>
      <Button variant="outline" size="sm" onClick={onRetry} className="self-start">
        Retry
      </Button>
    </AlertDescription>
  </Alert>
);
ErrorState.displayName = 'ErrorState';

export { ErrorState };
export type { ErrorStateProps };
